export type AirUploadParams = {
	locationId: string;
	path: string;
};

export enum NameOfAirUploadParams {
	LocationId = "id",
	UploadPath = "path",
}
